module.exports = __webpack_public_path__ + "media/images/site/CTERCEIRAO_FULL_TIME-beb4a36230e86c4e4e2cfd9d8500aee3.jpg";